import _jsx from '@babel/runtime/helpers/jsx';
import React, { useContext } from 'react';
import classNames from 'classnames';
import { Text, Title } from '@andes/typography';
import { Thumbnail } from '@andes/thumbnail';
import { AndesContext } from '@andes/context';
import isWebviewIOSOs from '@andes/common/build/utils/isWebviewIOS';
import { Button } from '@andes/button';
const namespace = 'andes-empty-state';
const EmptyStateWithIcon = _ref => {
  let {
    asset: Icon,
    className,
    description
  } = _ref;
  const containerClassNames = classNames("".concat(namespace, "__container"), "".concat(namespace, "__container--icon"), className);
  return /*#__PURE__*/_jsx("div", {
    className: containerClassNames
  }, void 0, /*#__PURE__*/_jsx(Thumbnail, {
    className: "".concat(namespace, "__thumbnail"),
    size: "32"
  }, void 0, Icon), /*#__PURE__*/_jsx(Text, {
    size: "s"
  }, void 0, description));
};
var EmptyStateWithIcon$1 = EmptyStateWithIcon;
const EmptyStateWithIllustration = _ref => {
  let {
    action,
    asset: Illustration,
    className,
    description,
    size = 'large',
    title
  } = _ref;
  const isLink = ! /*#__PURE__*/React.isValidElement(action) && (action === null || action === void 0 ? void 0 : action.href);
  const {
    device
  } = useContext(AndesContext);
  const isWebviewIOS = isWebviewIOSOs(device);
  const containerClassNames = classNames(className, "".concat(namespace, "__container"), "".concat(namespace, "__container--illustration"), {
    ["".concat(namespace, "__container--webview-ios")]: isWebviewIOS
  });
  const actionClassNames = classNames("".concat(namespace, "__action"), {
    ["".concat(namespace, "__action--link")]: isLink
  });
  return /*#__PURE__*/_jsx("div", {
    className: containerClassNames
  }, void 0, Illustration && /*#__PURE__*/_jsx("div", {
    className: "".concat(namespace, "__illustration")
  }, void 0, Illustration), /*#__PURE__*/_jsx(Title, {
    className: "".concat(namespace, "__title"),
    component: "h2",
    size: size === 'large' ? 's' : 'xs'
  }, void 0, title), /*#__PURE__*/_jsx(Text, {
    className: "".concat(namespace, "__description"),
    size: "s"
  }, void 0, description), /*#__PURE__*/React.isValidElement(action) ? action : action && /*#__PURE__*/_jsx(Button, {
    className: actionClassNames,
    hierarchy: isLink ? 'transparent' : 'loud',
    size: size === 'large' && !isLink ? 'large' : 'medium',
    href: action === null || action === void 0 ? void 0 : action.href,
    onClick: action === null || action === void 0 ? void 0 : action.onClick
  }, void 0, action === null || action === void 0 ? void 0 : action.text));
};
var EmptyStateWithIllustration$1 = EmptyStateWithIllustration;
export { EmptyStateWithIcon$1 as EmptyStateWithIcon, EmptyStateWithIllustration$1 as EmptyStateWithIllustration };
